import { render, staticRenderFns } from "./CharacterImage.vue?vue&type=template&id=0f274f2e&scoped=true&"
import script from "./CharacterImage.vue?vue&type=script&lang=js&"
export * from "./CharacterImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f274f2e",
  null
  
)

export default component.exports